var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "rpd-saved-drawer",
      attrs: {
        value: _vm.drawer,
        temporary: "",
        fixed: "",
        right: "",
        width: "360",
      },
      on: {
        input: function ($event) {
          return _vm.$emit("update:drawer", $event)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "drawer__head" },
        [
          _c("h2", [_vm._v("Saved queries")]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "", flat: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("update:drawer", false)
                },
              },
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "drawer__body" },
        [
          _vm.loading
            ? _c("v-progress-linear", {
                attrs: { height: 2, color: "info", indeterminate: "" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.unavailable
            ? _c("div", { staticClass: "drawer__empty" }, [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_vm._v("cloud_off")]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "drawer__empty-title" }, [
                  _vm._v("Saved queries are unavailable"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "drawer__empty-detail" }, [
                  _vm._v(
                    "\n        The saved-query store could not be reached. Nothing has been lost — reload the page in a\n        few minutes, and let us know if it keeps happening.\n      "
                  ),
                ]),
              ])
            : !_vm.queries.length
            ? _c("div", { staticClass: "drawer__empty" }, [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_vm._v("folder_open")]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "drawer__empty-title" }, [
                  _vm._v("Nothing saved yet"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "drawer__empty-detail" }, [
                  _vm._v(
                    "\n        Save a pairing and its criteria to reopen it later without rebuilding the filters.\n      "
                  ),
                ]),
              ])
            : _c(
                "ul",
                { staticClass: "drawer__list" },
                _vm._l(_vm.queries, function (query) {
                  return _c(
                    "li",
                    { key: query.Id, staticClass: "drawer__item" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "drawer__item-main",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("load:query", query.Id)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "drawer__item-name" }, [
                            _vm._v(_vm._s(query.Name)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "drawer__item-meta" }, [
                            _c(
                              "span",
                              {
                                staticClass: "chip",
                                class: query.IsShared
                                  ? "chip--info"
                                  : "chip--neutral",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      query.IsShared ? "Shared" : "Private"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "field-note" }, [
                              _vm._v(_vm._s(query.OwnerDisplayName || "You")),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "field-note" }, [
                              _vm._v(_vm._s(_vm.updatedAt(query.UpdatedAt))),
                            ]),
                          ]),
                          _vm._v(" "),
                          query.Description
                            ? _c(
                                "span",
                                { staticClass: "drawer__item-description" },
                                [_vm._v(_vm._s(query.Description))]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            flat: "",
                            disabled: !query.CanDelete,
                            title: query.CanDelete
                              ? "Delete this query"
                              : "Only the owner can delete this query",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("delete:query", query)
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("delete_outline")])],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }